import config from "../../config";

export const setTitle = (title?: string) => {
    if (!title) {
        document.title = config.APP_TITLE!;
        return;
    }
    document.title = `${config.APP_TITLE} | ${title}`;
}
